import axios from 'axios';
import RubrosTabla from '../types/RubrosTabla';

async function InsertarRubro(RubroNuevo: RubrosTabla) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_rubro";
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "rubro": {
                    "rubro": RubroNuevo.rubro,
                    "habilitado": RubroNuevo.habilitado,
                    "dado_de_baja": RubroNuevo.dado_de_baja
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarRubro;